// Engagement lifecycle stages (PRD §10 pipeline) and their mapping onto the
// single free-tier HubSpot pipeline ("VibeProSoft Revenue Pipeline", id `default`).
// The detailed consulting lifecycle lives HERE (D1); HubSpot gets the coarse stage.

export const ENGAGEMENT_STAGES = [
  'new_inquiry',
  'auto_qualified',
  'needs_review',
  'discovery_scheduled',
  'assessment_in_progress',
  'roadmap_delivered',
  'proposal_sent',
  'implementation_active',
  'closed_won',
  'closed_lost',
] as const;

export type EngagementStage = (typeof ENGAGEMENT_STAGES)[number];

export const STAGE_LABELS: Record<EngagementStage, string> = {
  new_inquiry: 'New Inquiry',
  auto_qualified: 'Auto-Qualified',
  needs_review: 'Needs Review',
  discovery_scheduled: 'Discovery Scheduled',
  assessment_in_progress: 'Assessment In Progress',
  roadmap_delivered: 'Roadmap Delivered',
  proposal_sent: 'Proposal Sent',
  implementation_active: 'Implementation Active',
  closed_won: 'Closed Won',
  closed_lost: 'Closed Lost',
};

/** Stage ids are the original HubSpot defaults; labels were re-mapped when the
 *  unified pipeline was built (e.g. `appointmentscheduled` shows as "New Inquiry"). */
export const HUBSPOT_DEALSTAGE_BY_STAGE: Record<EngagementStage, string> = {
  new_inquiry: 'appointmentscheduled',
  auto_qualified: 'qualifiedtobuy',
  needs_review: 'appointmentscheduled',
  discovery_scheduled: 'qualifiedtobuy',
  assessment_in_progress: 'presentationscheduled',
  roadmap_delivered: 'presentationscheduled',
  proposal_sent: 'decisionmakerboughtin',
  implementation_active: 'closedwon',
  closed_won: 'closedwon',
  closed_lost: 'closedlost',
};

export function isEngagementStage(v: string): v is EngagementStage {
  return (ENGAGEMENT_STAGES as readonly string[]).includes(v);
}

export const DATA_CLASSIFICATIONS = ['public', 'internal', 'confidential', 'restricted'] as const;
export type DataClassification = (typeof DATA_CLASSIFICATIONS)[number];
